import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { OPEN_ACCESS_FEATURES } from '../lib/openAccess';

/**
 * Loads org subscription (includes plan features from backend).
 * Relies on AuthContext setting axios default Authorization header.
 */
export function useOrgSubscription(orgId) {
  const [loading, setLoading] = useState(!!orgId);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (!orgId) {
      setSubscription(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    axios
      .get(`${API_URL}/organizations/${orgId}/subscription`)
      .then((res) => {
        if (!cancelled) setSubscription(res.data);
      })
      .catch(() => {
        if (!cancelled) setSubscription(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [orgId]);

  const features = subscription?.features
    ? { ...OPEN_ACCESS_FEATURES, ...subscription.features }
    : OPEN_ACCESS_FEATURES;
  return { loading, subscription, features };
}
